import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ToggleField } from 'view/components/toggle'
import { hideExpiredRejectedSelector } from 'selectors/gridSelectors'
import { Locale, Translation } from 'locale'
import { ToolbarToggleWrapper } from 'view/components/datagrid/toolbar/toolbarStyles'
import { GridActions } from 'store/grid'
import { GlobalGridSettings } from 'store/grid/gridTypes'

interface InitiatedNegotiationsToolbarSwitchProps {
  hideExpiredRejected: boolean
  onSaveGlobalGridSettings: (globalGridSettings: Partial<GlobalGridSettings>) => unknown
}

const mapStateToProps = createStructuredSelector({
  hideExpiredRejected: hideExpiredRejectedSelector
})

const mapDispatchToProps = {
  onSaveGlobalGridSettings: GridActions.saveGlobalGridSettings
}

const InitiatedNegotiationsToolbarSwitchComponent: React.FunctionComponent<InitiatedNegotiationsToolbarSwitchProps> = props => {
  const { hideExpiredRejected, onSaveGlobalGridSettings } = props

  return (
    <ToolbarToggleWrapper>
      <ToggleField
        label={Locale.translate(Translation.TC_HIDE_EXPIRED_REJECTED)}
        checked={hideExpiredRejected}
        onUpdate={(value: boolean) => onSaveGlobalGridSettings({ hideExpiredRejectedInInitiated: value })}
      />
    </ToolbarToggleWrapper>
  )
}

export const InitiatedNegotiationsToolbarSwitch = connect(mapStateToProps, mapDispatchToProps)(InitiatedNegotiationsToolbarSwitchComponent)
